import React, { useState, useEffect } from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Box,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import ChatIcon from '@mui/icons-material/Chat';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const routes = ['/profile', '/profile', '/messages', '/profile'];
  const [value, setValue] = useState(-1);
  const isFullScreenPage = location.pathname.startsWith('/messages/');

  useEffect(() => {
    const currentIndex = routes.indexOf(location.pathname);
    setValue(currentIndex);
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(routes[newValue]);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: isFullScreenPage ? 'env(safe-area-inset-bottom)' : 0,
      }}
    >
      {/* Sayfa içeriği */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          paddingBottom: isFullScreenPage
            ? 'env(safe-area-inset-bottom)'
            : 'calc(64px + env(safe-area-inset-bottom))',
        }}
      >
        {isFullScreenPage ? (
          <Outlet />
        ) : (
          <Box sx={{ padding: 2 }}>
            <Outlet />
          </Box>
        )}
      </Box>

      {/* Alt sabit menü */}
      {!isFullScreenPage && (
        <Paper
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            borderTop: '1px solid #ddd',
            paddingBottom: 'env(safe-area-inset-bottom)',
          }}
          elevation={3}
        >
          <BottomNavigation value={value} onChange={handleChange} showLabels>
            <BottomNavigationAction 
              icon={<ShoppingCartIcon />} 
            />
            <BottomNavigationAction 
              icon={<ThumbUpIcon />} 
            />
            <BottomNavigationAction 
              icon={<ChatIcon />} 
            />
            <BottomNavigationAction 
              icon={<PersonIcon />} 
            />
          </BottomNavigation>
        </Paper>
      )}
    </Box>
  );
};

export default MainLayout;